'use strict';

class ContratoController {
  constructor(DataService, _, $log, Modal, apiUrl, Proyecto) {
    'ngInject';

    this.DataService = DataService;
    this._ = _;
    this.$log = $log;
    this.Modal = Modal;
    this.apiUrl = apiUrl;
    this.Proyecto = Proyecto;
  }

  $onInit() {
    this.prepararLista();
    this.documentos = this.getConfiguracion();
  }

  getConfiguracion() {
    return {
      lista: [
        {
          codigo: 'doc_contrato',
          nombre: 'Contrato',
          nombre_formulario: 'Contrato',
          tipo: 'DCONT',
          urlDescarga: `${this.apiUrl}proyectos/${this.proyecto.id_proyecto}/doc/DCONT/descargar`
        }
      ],
      uploadCallback: (file) => {
        var data = {
          documento: angular.copy(file)
        }
        this.DataService.put(`proyectos/${this.proyecto.id_proyecto}/doc/${this.getTipo(file)}/subir`, data).then(response => {
          if (response && response.finalizado) {
            this.asignarDatos(file, response.datos.documento);
          }
        });
      }
    };
  }

  verificarArchivosCargados() {
    this.documentos.lista.map(documento => {
      const FORMULARIO = this.getFormularioRegistrado(documento);
      if (FORMULARIO) {
        documento.registrado = true;
        documento.nombre_archivo = FORMULARIO.nombre_archivo;
      }
    });
  }

  prepararLista() {
    if (this.proyecto.formularios) {
      this.asignarPath();
    } else {
      this.DataService.get(`proyectos/${this.proyecto.id_proyecto}/doc`).then( result => {
        if (result && result.finalizado) {
          this.proyecto.formularios = result.datos.formularios;
          this.asignarPath();
          this.verificarArchivosCargados();
        }
      });
    }
  }

  asignarPath() {
    this.proyecto.formularios.map(formulario => {
      formulario.path = `${this.apiUrl}proyectos/${this.proyecto.id_proyecto}/doc/${formulario.codigo_documento}/descargar`
    });
  }

  asignarDatos(archivo, docCreado) {
    const index = this._.findIndex(this.documentos.lista, {codigo: archivo.name});
    this.documentos.lista[index].base64 = archivo.base64;
    this.documentos.lista[index].nombre_formulario = docCreado.nombre;
    this.documentos.lista[index].nombre_archivo = docCreado.nombre_archivo;
    this.documentos.lista[index].registrado = true;
    let formulario = this.getFormularioRegistrado(docCreado);
    if (!formulario) {
      if (!this.proyecto.formularios) {
        this.proyecto.formularios = [];
      }
      this.proyecto.formularios.push(docCreado);
    } else {
      formulario = docCreado;
    }
  }

  getFormularioRegistrado(documento) {
    return this._.find(this.proyecto.formularios, {codigo_documento: documento.tipo});
  }

  cambiar(documento) {
    if (documento.registrado) {
      this.Modal.confirm(`¿Está seguro/a de cambiar el ${documento.nombre}?`, () => {
        documento.registrado = false;
      }, null, null, 'Si, estoy seguro', 'Cancelar')
    }
  }

  verDocumento(documento) {
    const URL = `proyectos/${this.proyecto.id_proyecto}/doc/${documento.tipo}`;
    this.Modal.showDocumentBase64(URL, `${documento.nombre}`);
  }

  getTipo(archivo) {
    return this._.find(this.documentos.lista, {codigo: archivo.name}).tipo;
  }
}

export default ContratoController



// WEBPACK FOOTER //
// ./src/app/components/proyectos/c-proyectos/contrato/contrato.controller.js